// Utility functions for calendar event mapping and fetching
export const mapDefaultEvent = (row) => ({
  id: row.id,
  title: row.info,
  start: row.startDate,
  end: row.endDate,
  resourceId: row.personId,
  approvers: row.approvers,
  causeCode: row.causeCode,
  icdCode: row.icdCode,
  ownAnnouncement: row.ownAnnouncement,
  dayHours: row.dayHours,
  status: row.status,
  isHoliday: false,
});